export const ExpandLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M11.5003 16L19.5003 8L20.9336 9.43333L14.3336 16L20.9003 22.5667L19.4669 24L11.5003 16Z" fill="black" />
  </svg>
);
